export enum FileType {
  PESC = 1,
  TransferOrder = 2,
  Attachment = 3,
  TicketUpload = 4,
  LoadFile = 5,
  PrecedentFile = 6,
}
